require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-angular-part-1-why-choose-angular.json") })
        }
      }, "path---blog-angular-part-1-why-choose-angular");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-angular-part-1-why-choose-angular!./.cache/json/blog-angular-part-1-why-choose-angular.json
// module id = 588
// module chunks = 231608221292675